export enum ConnectionType {
    OwaNetCoreSignalR = "OwaNetCoreSignalR",
    ONOSSignalR = "ONOSSignalR",
    OwaClassicSignalR = "OwaClassicSignalR"
}
